import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LigipaasetavusTekst = _resolveComponent("LigipaasetavusTekst")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "pa-6 pa-sm-10" }, {
    default: _withCtx(() => [
      _createVNode(_component_LigipaasetavusTekst)
    ]),
    _: 1
  }))
}